import { render, staticRenderFns } from "./RatingDepartmentGrid.vue?vue&type=template&id=1d46d328"
import script from "./RatingDepartmentGrid.vue?vue&type=script&lang=js"
export * from "./RatingDepartmentGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports